export const ExternalSwitches = {
  WEB_ATTRIBUTION_SURVEY: "web_attribution_survey_v2",
  WEB_EXTERNAL_PARENTS_FIRST: "web_external_parents_first_v4",
  WEB_EXTERNAL_ACTIVITY_CORNER_POPUP_SIGNUP: "web_external_activity_corner_popup_signup",
  WEB_EXTERNAL_LOGIN_TO_HOME: "redirect_parent_login_home_v2",
  WEB_EXTERNAL_SL_REDIRECT_SIGNUP_LOGIN: "web_external_sl_redirect_signup_login_v2",
  WEB_EXTERNAL_TEACHER_EMAIL_FIRST_LOGIN: "web_external_teacher_email_first_login_v4",
  WEB_EXTERNAL_HOMEPAGE_EXPERIMENT_QA_FS: "web_external_homepage_experiment_test_fs",
} as const;

export const TeacherSwitches = {} as const;

export const featureSwitches = Object.values({ ...ExternalSwitches, ...TeacherSwitches });
